<!-- <script setup>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import searchStore from "@/Store/searchStore";
import { useClassStore } from "@/Store/className";



const classStore = useClassStore();
 const navItems = computed(() => classStore.navItems);

// In your component:
onMounted(() => {
  const classStore = useClassStore();
  
  watch(
    () => classStore.classInfoList,
    (newValue) => {
      if (newValue.length) {
        classStore.updateNavItems();
        console.log("Store navItems:", classStore.navItems);
      }
    },
    { immediate: true }
  );
});


// onMounted(() => {

//   const classStore = useClassStore();
//   const className = computed(() => classStore.classInfoList);
//   console.log("Class Name:", className.value);

//   const navItems = [];
//   // if (Array.isArray(className.value)) {
//   //   const name = className.value.map((item) => {
//   //     return { title: item.name, link: `/students/${item.id}` };
//   //   });
//   //   navItems.push(...name);
//   // } else {
//   //   console.warn("className.value is not an array:", className.value);
//   // }

//   for (const [key, value] of Object.entries(object1)) {
//   console.log(`${key}: ${value}`);
// }

//   console.log("Class Name nav:", navItems);
//   // console.log("Class Name nav:", className.value);




// })


// onMounted(() => {
//  
//   const { classInfoList, loading, error } = useClassStore(classStore);
  
//   // Fetch data when component mounts
//   classStore.fetchClassInfoList();
  
//   watch([classInfoList, loading], ([newClassInfo, isLoading]) => {
//     if (!isLoading && newClassInfo) {
//       const navItems = newClassInfo.map(item => ({
//         title: item.name,
//         link: `/students/${item.id}`
//       }));
//       console.log("Navigation Items:", navItems);
//     }
//   }, { immediate: true });
// });

onMounted(() => {

  const className = computed(() => classStore.classInfoList);

  watch(className, (newValue) => {
    if (newValue) {
      console.log("Class Name:", newValue);

      const navItems = [];
      console.log("Class Name nav near var:", navItems);
      if (Array.isArray(newValue)) {
        console.log("outside map")
        const name = newValue.map((item) => {
          console.log("inside map",item)
          return { title: item.name, link: `/students/${item.id}` };
        });
        navItems.push(...name);
      }

      console.log("Class Name nav:", navItems);
    }
  }, { immediate: true }); // immediate: true runs the watcher once immediately
});
// const navItems = [];



// const name = test.map((item) => {
//   console.log("inside map", item)
//   return { title: item.name, link: `/students/${item.id}` };
// });

// navItems.push(...name);



const searchQuery = computed(() => searchStore.state.searchQuery);
const showDropdown = ref(false);
const dropdownRef = ref(null);




const filteredItems = computed(() => {
  if (!searchQuery.value) return [];
  return classStore.navItems.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

watch(searchQuery, (val) => {
  showDropdown.value = val && filteredItems.value.length > 0;
});


function handleClickOutside(event) {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    showDropdown.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script> -->
<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import searchStore from "@/Store/searchStore";
import { useClassStore } from "@/Store/className";

const classStore = useClassStore();
const searchQuery = computed(() => searchStore.state.searchQuery);
const showDropdown = ref(false);
const dropdownRef = ref(null);

const navItems = computed(() => classStore.navItems);

// Filtered items for search
const filteredItems = computed(() => {
  if (!searchQuery.value) return [];
  return navItems.value.filter(item =>
    item.title.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

// Watch for search query changes to show/hide dropdown
watch(searchQuery, (val) => {
  showDropdown.value = val && filteredItems.value.length > 0;
});

// Click outside handler
function handleClickOutside(event) {
  return
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    showDropdown.value = false;
  }
}

// Setup and cleanup
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  
  // Initialize data if needed
  if (classStore.classInfoList.length === 0) {
    classStore.fetchClassInfoList(); // Assuming you have this action
  }
  
  // Single watcher for class info changes
  watch(
    () => classStore.classInfoList,
    (newValue) => {
      if (newValue.length) {
        classStore.updateNavItems();
      }
    },
    { immediate: true }
  );
});
function closeDropdown() {
  showDropdown.value = false;
}

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});


</script>

<template>
  <v-sheet class="position-relative" style="max-width: 500px; margin: 0 auto;" ref="dropdownRef">
    <!-- Search Input -->
    <form class="src-form position-relative" @submit.prevent>
      <input type="text" class="form-control" placeholder="Search here....." v-model="searchStore.state.searchQuery" />
     
      <button type="submit"
        class="src-btn position-absolute top-50 end-0 translate-middle-y bg-transparent p-0 border-0">
        <span class="material-symbols-outlined">search</span>
      </button>
    </form>

    <!-- Dropdown Results -->
    <v-sheet v-if="showDropdown" class="dropdown-results position-absolute w-100  border rounded mt-1 shadow">
      <v-sheet class="p-2 border-bottom fw-semibold text-muted small">USER INTERFACE</v-sheet>
      <ul class="list-unstyled m-0">
        <li v-for="(item, index) in filteredItems" :key="index"
          class="dropdown-item px-3 py-2 d-flex align-items-center gap-3 hover-bg transition rounded">
          <!-- <v-sheet class="icon-circle d-flex justify-content-center align-items-center">
            <span class="material-symbols-outlined">{{ item.icon }}</span>
          </v-sheet> -->
          <RouterLink :to="item.link" class="text-decoration-none text-dark flex-grow-1 fw-medium"
            @click="closeDropdown">
            {{ item.title }}
          </RouterLink>
        </li>
      </ul>
    </v-sheet>
  </v-sheet>
</template>


<style scoped>
.dropdown-results {
  z-index: 1000;
  height: auto;
  overflow-y: auto;
  border-radius: 12px;
}

.icon-circle {
  width: 36px;
  height: 36px;
  /* background-color: #e9ecef; */
  border-radius: 50%;
  font-size: 20px;
  /* color: #495057; */
  transition: background-color 0.3s ease;
}

.dropdown-item {
  border-radius: 8px;
  transition: background-color 0.2s ease, transform 0.2s ease;
  cursor: pointer;
}

.dropdown-item:hover {
  /* background-color: #f1f3f5; */
  transform: translateY(1px);
}

.hover-bg:hover .icon-circle {
  /* background-color: #dee2e6; */
}
</style>
